export const getUrlParams = (): Record<string, string> => {
    let searchParams = {};

    new URLSearchParams(location.search).forEach((value, key) => {
        searchParams = { ...searchParams, [key]: value };
    });

    return searchParams;
};
